<fieldset class="fieldset">
  <legend class="fieldset-legend" data-test="section-label">File attachments</legend>
  <ul class="settings-list">
    <mode-email-setting
      id="csv-attachments"
      [disabledByWorkspaceSetting]="disableAttachments"
      [isDisabled]="disableAttachments"
      [selected]="selections.csv"
      (selectedChange)="attachmentsSelected.emit({ csv: $event })"
      data-test="csv-attachments"
      >CSVs of raw Query data (10 MB file size limit, ~8MB raw data)
    </mode-email-setting>
    <mode-email-setting
      id="pdf-attachments"
      [disabledByWorkspaceSetting]="disableAttachments"
      [isDisabled]="disableAttachments"
      [selected]="selections.pdf"
      (selectedChange)="attachmentsSelected.emit({ pdf: $event })"
      data-test="pdf-attachments"
      >Report PDF (may exclude custom formatting)
    </mode-email-setting>
  </ul>
</fieldset>
